var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('header',{staticClass:"header"},[_vm._v("加我微信")]),_c('div',{staticClass:"main"})])
}]

export { render, staticRenderFns }